import { connect } from 'react-redux';

import { TThunkDispatch, IApplicationState } from '../../types/redux';
import { setVisibleStickHeader } from '../../actions/stickHeader';
import { Hero, IHeroProps } from '../../components/Hero';
import { setVisibleStickBottom } from '../../actions/stickBottom';
import { defaultState as defaultStateFeedback } from '../../reducers/feedback';
import { scrollTo } from '../../utils/scrollTo';

type TStoreProps = Pick<
  IHeroProps,
  'isVisibleStickHeader' | 'feedbackTopPosition' | 'feedbackHeight' | 'isVisibleStickBottom' | 'isVisibleForm'
>;
type TDispatchProps = Pick<IHeroProps, 'setVisibleStickHeader' | 'setVisibleStickBottom'>;

export function mapStateToProps(state: IApplicationState): TStoreProps {
  const isVisibleForm =
    typeof state.feedback.isVisibleForm === 'boolean'
      ? state.feedback.isVisibleForm
      : (defaultStateFeedback.isVisibleForm as boolean);

  return {
    isVisibleStickHeader: state.stickHeader.isVisible,
    isVisibleStickBottom: state.stickBottom.isVisible,
    feedbackTopPosition: state.feedback.topPosition,
    feedbackHeight: state.feedback.height,
    isVisibleForm,
  };
}

export function mapDispatchToProps(dispatch: TThunkDispatch): TDispatchProps {
  return {
    setVisibleStickHeader: (visible: boolean) => dispatch(setVisibleStickHeader(visible)),
    setVisibleStickBottom: (visible: boolean) => dispatch(setVisibleStickBottom(visible)),
  };
}

export function mergeProps(storeProps: TStoreProps, dispatchProps: TDispatchProps) {
  const { feedbackTopPosition } = storeProps;

  return {
    ...storeProps,
    ...dispatchProps,
    scrollToFeedback: () => scrollTo(feedbackTopPosition),
  };
}

export const HeroContainer = connect(mapStateToProps, mapDispatchToProps, mergeProps)(Hero);
